<template>
    <header class="mds-masthead">
        <div class="mds-masthead__inner">
            <div class="mds-masthead__left"></div>
            <div class="mds-masthead__logo-wrap">
                <template v-if="routeToUse !== 'mstar'">
                    <MorningstarLogo id="logo" />
                    <span class="mds-masthead__logo">{{ $t('LogoTitle') }}</span>
                </template>
                <template v-else>
                    <img src="/static/images/mstar-logotype-rm-red-1.svg" style="height:80px;width:220px;padding: inherit;"/>
                </template>
            </div>
            <div class="mds-masthead__right"></div>
        </div>
    </header>
</template>

<script>
import MorningstarLogo from "@mds-assets/mds_icons.svg?morningstar-logo";

export default {
    data () {
        return {
            routeToUse: this.$router.currentRoute.path.toLowerCase().includes('morningstarlifetimeindexfunds') ? 'mstar' : ''
        };
    },
    components: {
        MorningstarLogo
    },
    watch: {
        $route(to, from) {
            this.routeToUse = to.path.toLowerCase().includes('morningstarlifetimeindexfunds') ? 'mstar' : '';
        }
    }
};
</script>

<style lang="scss" scoped>
    #logo {
        fill: $mds-color-red-50;
        height: $mds-space-2-x;
    }

    .mds-masthead__logo {
        color: $mds-color-red-50;
        display: inline-block;
        font-size: 1.3rem;
        font-weight: $mds-font-weight-thin
    }

    @media #{$bp-desktop} {
        #logo {
            height: 1.875rem;
            width: 8.624rem;
        }

        .mds-masthead__logo {
            font-size: 2.5rem;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Header.vue